var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full db-ChromeMainContent overflow-hidden"},[_c('left-nav',{attrs:{"leftNavItems":_vm.leftNavItems,"title":"Report"}}),_c('div',{staticClass:"w-full h-full mt-32 overflow-hidden"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }